import { alertConstants } from "./types";

const alertActions = {
  success,
  error,
  showError,
  clear
};

const loading = {
  showLoading,
  hideLoading
};

function success(message, redirect) {
  return { type: alertConstants.SUCCESS, message, redirect };
}

function error(message) {
  return { type: alertConstants.ERROR, message };
}

function showError(message) {
  return { type: alertConstants.SHOW_ERROR, message };
}

function clear() {
  return { type: alertConstants.CLEAR };
}

const showModal = () => {
  return { type: alertConstants.SHOW_MODAL };
};

const hideModal = () => {
  return { type: alertConstants.HIDE_MODAL };
};

function showLoading() {
  return { type: alertConstants.SHOW_LOADING };
};

function hideLoading() {
  return { type: alertConstants.HIDE_LOADING };
};

export { alertActions, loading, showModal, hideModal };
